module.exports = __webpack_public_path__ + "selwebee_spt_candy-ENGLISH-5e6c33a8fd681967bf34387de1e6fec7.png";